import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { SalaryService } from 'src/app/Service/Salary/Salary.service';

@Component({
  selector: 'app-SalaryFish',
  templateUrl: './SalaryFish.component.html',
  styleUrls: ['./SalaryFish.component.scss']
})
export class SalaryFishComponent implements OnInit {

  @ViewChild('salaryFishPdf') salaryFishPdf?: ElementRef<HTMLElement>;

  @Output() outter_Salary= new EventEmitter<number>();
  @Input() innerPersonId:number=0
  @Input() innerYear:number=0
  @Input() innerMonth:number=0
  Procssing:boolean=false
  PdfProcessing:boolean=false
  DataList_Salary:any
  private autoPdf = false;

  constructor(
    private Salary_Service:SalaryService,
    private Alertify_Service: AlertifyService,
    private route: ActivatedRoute,
    private changeDetector: ChangeDetectorRef
  ) { }

  ngOnInit() {
    if (!this.innerPersonId) {
      this.innerPersonId = Number(this.route.snapshot.queryParamMap.get('personId') || 0);
      this.innerYear = Number(this.route.snapshot.queryParamMap.get('year') || 0);
      this.innerMonth = Number(this.route.snapshot.queryParamMap.get('month') || 0);
    }
    this.autoPdf = this.route.snapshot.queryParamMap.get('autoPdf') === '1';
    this.ReadData_Salary()
  }

  ReadData_Salary(){
    this.Procssing=true
    this.Salary_Service.GetSalaryMonthFish(this.innerYear,this.innerMonth,this.innerPersonId).subscribe(
      data=>{
        this.DataList_Salary=data
        this.Procssing=false
        this.changeDetector.detectChanges();
        if (this.autoPdf) {
          this.autoPdf = false;
          this.exportPdf();
        }
      },error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

  async exportPdf(): Promise<void> {
    if (this.PdfProcessing || !this.DataList_Salary || !this.salaryFishPdf) {
      return;
    }
    this.PdfProcessing = true;
    try {
      if (document.fonts?.ready) {
        await document.fonts.ready;
      }
      await this.waitForRender();
      const element = this.salaryFishPdf.nativeElement;
      element.classList.add('pdf-export');
      await this.waitForRender();
      const canvas = await html2canvas(element, {
          scale: 2,
          useCORS: true,
          backgroundColor: '#ffffff',
          logging: false,
          width: element.scrollWidth,
          height: element.scrollHeight,
          windowWidth: element.scrollWidth,
          windowHeight: element.scrollHeight
        });
      element.classList.remove('pdf-export');

      const pdf = new jsPDF('landscape', 'mm', 'a4');
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
      const margin = 5;
      const maxWidth = pageWidth - margin * 2;
      const maxHeight = pageHeight - margin * 2;
      const ratio = Math.min(maxWidth / canvas.width, maxHeight / canvas.height);
      const finalWidth = canvas.width * ratio;
      const finalHeight = canvas.height * ratio;
      const x = (pageWidth - finalWidth) / 2;
      const y = (pageHeight - finalHeight) / 2;
      pdf.addImage(canvas.toDataURL('image/jpeg', 0.98), 'JPEG', x, y, finalWidth, finalHeight, undefined, 'FAST');
      const personName = this.sanitizeFileName(this.DataList_Salary['fullname'] || this.innerPersonId);
      pdf.save(`SalaryFish-${personName}-${this.innerYear}-${this.innerMonth}.pdf`);
    } catch (error) {
      console.error('Salary fish PDF export failed', error);
      this.Alertify_Service.ErrorMessage('خطا در ایجاد فایل PDF فیش حقوقی');
    } finally {
      this.salaryFishPdf?.nativeElement.classList.remove('pdf-export');
      this.PdfProcessing = false;
      this.changeDetector.detectChanges();
    }
  }

  private waitForRender(): Promise<void> {
    return new Promise(resolve => requestAnimationFrame(() => requestAnimationFrame(() => resolve())));
  }

  private sanitizeFileName(value: unknown): string {
    return String(value || 'Salary')
      .replace(/[<>:"/\\|?*\u0000-\u001F]/g, '-')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '') || 'Salary';
  }


  calcKosorat(item:any){
    return Number(item['maliatPay'])+Number(item['bimehKargar'])
  }

  getDeductionAmount(item: any, fieldNames: string[]): number {
    const fieldName = fieldNames.find(name => item?.[name] !== null && item?.[name] !== undefined && item?.[name] !== '');
    const value = fieldName ? Number(item[fieldName]) : 0;
    return Number.isFinite(value) ? value : 0;
  }


  calcTahahol(item:any){
    if(Number(item['salaryRecord']['tahahol'])>0)
      return "متاهل"  
    else 
      return "مجرد"  
  }

  onBack(){
    this.outter_Salary.emit(-1);
  }

}
